import React, { useState, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import Modal from "react-modal";
import { toast } from "react-toastify";

const UserProfile = () => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "40%",
      borderRadius: "5px",
      maxWidth: "300px",
      maxHeight: "390px",
      height: "390px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [data, setData] = useState([]);
  const [passwordClose, setPasswordClose] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [backImage, setBackImage] = useState();
  const [profileUrl, setprofileUrl] = useState(false);
  const { sendRequest: getUser } = useHttp();

  const getUserData=()=>{
    getUser(
      {
        url: `/api/employeeDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&userId=${localStorage.getItem("id")}`,
      },
      (myres) => {
        var res=myres.data
        console.log(res[0]);
        setData(res[0]);
        setBackImage(res[0]?.profileurl || "");
      }
    );
  }

  useEffect(() => {
 getUserData();
  }, [getUser]);

  const { error: err, sendRequest: ChangePassword } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    if (newPassword != confirmPassword) {
      toast.error(" new password and confirm password not match");
      return;
    }

    const input = {
      id: data && data.userId,
      password: oldPassword,
      new_password: newPassword,

      //   orgId: localStorage.getItem("orgId"),
    };
    //console.log("data", data);

    ChangePassword(
      {
        url: "/api/changePassword/",
        method: "POST",
        body: input,
      },
      (data) => {
        //console.log(data);
        toast.success(`Password change successfully`);
        setPasswordClose(false);
        setNewPassword("");
        setOldPassword("");
        setConfirmPassword("");
      },
      (error) => {
        //  console.error("Error:", error);
        // toast.error("Password not change check your credential ");
        toast.error(error);
      }
    );
  };

    const attachmentFolder=localStorage.getItem("attachmentFolder");

  const uploadProImage = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/userProfile/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        //console.log();
        setBackImage(`${data.url}`);
        setprofileUrl(data.url);
      })
      .catch((err) => console.error(err));
  };

  const { sendRequest: updateProfile } = useHttp();

  useEffect(() => {
    const inputData = {
      empId: parseInt(localStorage.getItem("empId")),
      profileurl: profileUrl,
    };
    console.log(inputData);
    if (profileUrl) {
      updateProfile(
        {
          url: "/api/employeeProfileImageUplaod/",
          method: "PUT",
          body: inputData,
        },
        (data) => {
          toast.success(data);
          getUserData();
        },
        (error) => {

          toast.error(error);
          getUserData();
        }
      );
    }
  }, [profileUrl]);

  return (
    <>
      {passwordClose && (
        <Modal isOpen={true} style={modalStyles}>
          <h3>Change Password</h3>

          <form onSubmit={submitHandler}>
            <div className="row">
              <div className="col-md-12 col-6">
                <label htmlFor="newPassword">Old Password</label>

                <input
                  type="text"
                  id="newPassword"
                  className="form-control"
                  placeholder="Old Password"
                  value={oldPassword}
                  onChange={(event) => setOldPassword(event.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-6">
                <label htmlFor="newPassword">New Password</label>
                <input
                  type="text"
                  id="newPassword"
                  className="form-control"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(event) => setNewPassword(event.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-6">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  type="text"
                  id="confirmPassword"
                  className="form-control"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  required
                />
              </div>
            </div>
            <div className="mx-4 my-4">
              <button type="submit" className="btn btn-sm btn-primary">
                Save
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={() => {
                  setPasswordClose(false);
                }}
              >
                Cancel
              </button>
            </div>
          </form>

          <br />
        </Modal>
      )}
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row text-center">
              <div className="col-sm-12">
                <h3 className="">User Profile</h3>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                {/* Profile Image */}
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Personal Information</h3>
                  </div>

                  <div className="card-body box-profile">
                    <div className="row">
                      <div className="col-md-5 mx-5">
                        {" "}
                        <img
                          className="profile-user-img img-fluid img-circle"
                          src={`${process.env.REACT_APP_FILE_URL}${backImage}`}
                          alt="Profile"
                        />
                      </div>
                      <div className="col-md-4">
                        {" "}
                        <h3 className="profile-username">
                          {data && data.employeeName}
                        </h3>{" "}
                        <p className="">{data && data.designationName}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-10">
                        <label style={{ cursor: "pointer", color: "blue" }}>
                          <input
                            type="file"
                            className="custom-file-input"
                            id="file"
                            accept="image/*"
                            onChange={uploadProImage}
                          />
                          Change Profile Image
                        </label>
                      </div>
                    </div>

                    <ul className="list-group list-group-unbordered">
                      <li className="list-group-item">
                        <b>Employee Code</b>{" "}
                        <div className="float-right">
                          {" "}
                          {data && data.employeeCode}
                        </div>
                      </li>
                      <li className="list-group-item">
                        <b>Department</b>{" "}
                        <div className="float-right">
                          {data && data.departmentName}
                        </div>
                      </li>
                      <li className="list-group-item">
                        <b>User Case</b>{" "}
                        <div className="float-right">
                          {data && data.useCase}
                        </div>
                      </li>
                      <li className="list-group-item">
                        <b>Status</b>{" "}
                        <div className="float-right">
                          {" "}
                          {data && data.activeStatus ? "Active" : "Deactive"}
                        </div>
                      </li>
                      <li className="list-group-item">
                        <b>Warehouse Name</b>{" "}
                        <div className="float-right">
                          {" "}
                          {data && data.warehouseName}
                        </div>
                      </li>
                    </ul>

                    <a href="#" onClick={() => setPasswordClose(true)}>
                      Change Password
                    </a>
                  </div>
                  <br />
                  {/* /.card-body */}
                </div>
                {/* /.card */}
                {/* About Me Box */}
              </div>
              <div className="col-md-6">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Contact Information</h3>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    <strong>
                      <i className="fas  fa-solid fa-address-card mr-1" />{" "}
                      Contact Number
                    </strong>
                    <p className="text-muted"> {data && data.contactNo}</p>
                    <hr />
                    <strong>
                      <i className="fa-solid fab fa-whatsapp"></i> WhatsApp
                      Number
                    </strong>
                    <p className="text-muted"> {data && data.whatsappNo}</p>
                    <hr />
                    <strong>
                      <i className="fas fa-solid fa-envelope mr-1"></i> Email
                    </strong>
                    <p className="text-muted">
                      <span className="tag tag-danger">
                        {" "}
                        {data && data.emailId}
                      </span>
                    </p>
                    <hr />
                    <strong>
                      <i className="fas fa-sim-card mr-1" /> Work Contact
                    </strong>
                    <p className="text-muted"> {data && data.workContactNo}</p>
                    <hr />
                    <strong>
                      <i className="fas fa-solid fa-inbox mr-1"></i>Work Email
                    </strong>
                    <p className="text-muted"> {data && data.workEmailId}</p>
                    <hr />
                    <strong>
                      <i className="fas fa-map-marker-alt mr-1" />
                      {data.address &&
                        data.address[0].addressType + " Address: "}
                    </strong>
                    <p className="text-muted">
                      {" "}
                      {data.address &&
                        data.address[0].city + " " + data.address[0].state}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default UserProfile;
